import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"



export default createStore({
  state: {
    menuItemIndex: "",
    user: {},
    unreadCount:0,
    historyurl:"/common/role",
  },
  mutations: {
    // 修改用户信息
    setUser(state, payload) {
      state.user = payload
    },
    // 修改用户头像
    setUserPic(state, payload) {
      state.user.pic = payload
    },
    // 修改菜单激活项
    setMenuItemIndex(state, payload) {
      state.menuItemIndex = payload
    },
    // 修改未读消息情况
    setUnreadCount(state,payload) {
      state.unreadCount = payload
    },
    // 修改未读消息情况
    setHistoryUrl(state,payload) {
      state.historyurl = payload
    },
    // 重置所有状态为初始状态
    resetState(state) {
      state.user = {}
      state.menuItemIndex = ""
    }
  },
  actions: {
  },
  modules: {
  },
  //把数据存储到本地存储空间
  plugins: [
    createPersistedState({
      key: 'conferenceStore',
      storage: window.localStorage,
    }),
  ],
})
